"use strict";
// VehicleModelDTO.ts
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicModelDTO = exports.VehicleModelUpdateDTO = exports.VehicleModelCreateDTO = exports.VehicleModelGetUniqueDTO = exports.VehicleModelGetDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const BaseDTO_1 = require("./BaseDTO");
const Vehicle_1 = require("../../../models/Vehicle");
const VehicleMake_1 = require("../../../models/VehicleMake");
class VehicleModelGetDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleModelGetDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
exports.VehicleModelGetDTO = VehicleModelGetDTO;
class VehicleModelGetUniqueDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleModelGetUniqueDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.instanceToPlain)(this);
    }
}
exports.VehicleModelGetUniqueDTO = VehicleModelGetUniqueDTO;
class VehicleModelCreateDTO extends BaseDTO_1.BaseCreateDTO {
    // NOTE:
    // - We are not validating the slug field because it is automatically generated from the name field.
    // - We cannot create a attach vehicles and models to a make during creation because the make should be created first and then the vehicles and models should be created and attached to the make.
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleModelCreateDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.Matches)(/^[a-zA-Z0-9\s\-\_]*$/, {
        message: "Name can only contain letters, numbers, spaces, hyphens, and underscores.",
    }),
    __metadata("design:type", String)
], VehicleModelCreateDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleModelCreateDTO.prototype, "image", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleModelCreateDTO.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleModelCreateDTO.prototype, "metaTitle", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleModelCreateDTO.prototype, "metaDescription", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleModelCreateDTO.prototype, "metaKeywords", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => VehicleMake_1.VehicleMake) // This transforms each object in the array to the OtherDetailsDTO class
    ,
    __metadata("design:type", VehicleMake_1.VehicleMake)
], VehicleModelCreateDTO.prototype, "make", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => Vehicle_1.Vehicle) // This transforms each object in the array to the OtherDetailsDTO class
    ,
    __metadata("design:type", Array)
], VehicleModelCreateDTO.prototype, "vehicles", void 0);
exports.VehicleModelCreateDTO = VehicleModelCreateDTO;
class VehicleModelUpdateDTO extends BaseDTO_1.BaseUpdateDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleModelUpdateDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Matches)(/^[a-zA-Z0-9\s\-\_]*$/, {
        message: "Name can only contain letters, numbers, spaces, hyphens, and underscores.",
    }),
    __metadata("design:type", String)
], VehicleModelUpdateDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleModelUpdateDTO.prototype, "image", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleModelUpdateDTO.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleModelUpdateDTO.prototype, "metaTitle", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleModelUpdateDTO.prototype, "metaDescription", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleModelUpdateDTO.prototype, "metaKeywords", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], VehicleModelUpdateDTO.prototype, "isActive", void 0);
exports.VehicleModelUpdateDTO = VehicleModelUpdateDTO;
class DynamicModelDTO {
    validate() {
        if (!this.existingId && !this.new) {
            throw new Error("Either existingId or new details must be provided.");
        }
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(DynamicModelDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], DynamicModelDTO.prototype, "existingId", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => VehicleModelCreateDTO),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", VehicleModelCreateDTO)
], DynamicModelDTO.prototype, "new", void 0);
exports.DynamicModelDTO = DynamicModelDTO;
